import React, { useEffect, useRef } from "react";
import Modal from "../UIElements/Modal";
import { Icon } from "../UIElements/Icon";
import { Button } from "../UIElements/Button";

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
  itemType = "Item",
  title,
  subtitle,
  confirmButtonText,
  isLoading = false,
  detailNote = "This action cannot be undone.",
  confirmLoadingText = "Deleting...",
}) => {
  const contentRef = useRef(null);
  const cancelRef = useRef(null);
  const wasLoadingRef = useRef(isLoading);
  useEffect(() => {
    const pendingEnded = wasLoadingRef.current && !isLoading;
    wasLoadingRef.current = isLoading;
    const dialog = contentRef.current?.closest(
      '[role="dialog"], [role="alertdialog"]',
    );
    if (isOpen && pendingEnded && !dialog?.contains(document.activeElement)) {
      cancelRef.current?.focus();
    }
  }, [isOpen, isLoading]);
  const defaultTitle = title || `Delete ${itemType}`;
  const defaultSubtitle =
    subtitle ||
    `Are you sure you want to delete this ${itemType.toLowerCase()}?`;
  const defaultConfirmText = confirmButtonText || `Delete ${itemType}`;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={defaultTitle}
      subtitle={defaultSubtitle}
      maxWidth="max-w-md"
    >
      <div ref={contentRef} className="space-y-4">
        <div className="border-error rounded-md border bg-[var(--error-bg)] p-4">
          <div className="flex items-center space-x-3">
            <Icon name="AlertTriangle" className="text-error h-5 w-5" />
            <div>
              <h4 className="text-error text-sm font-medium">
                {itemName || "Item"}
              </h4>
              <p className="text-error mt-1 text-xs">{detailNote}</p>
            </div>
          </div>
        </div>
        <div className="flex space-x-3 pt-2">
          <Button
            ref={cancelRef}
            type="button"
            onClick={onClose}
            disabled={isLoading}
            variant="outline"
            className="flex-1 rounded-md px-4 py-2 text-sm font-medium"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            variant="destructive"
            className="flex-1 rounded-md px-4 py-2 text-sm font-medium"
          >
            {isLoading ? confirmLoadingText : defaultConfirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
